"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GridConstants = exports.OpenType = exports.BlobRefType = void 0;
// Binary
// Below types are allowing us to send one or more binary contents contained in other schema objects
// Will be sent more efficiently over the network
var BlobRefType;
(function (BlobRefType) {
  // If this is set then there is no way to get the binary data
  BlobRefType[BlobRefType["None"] = 0] = "None";
  // When this is set value is URL we can simply call HTTPS GET to fetch binary data. This URL must be on the AL service allow-list.
  BlobRefType[BlobRefType["HttpsGetDownloadUrl"] = 1] = "HttpsGetDownloadUrl";
})(BlobRefType = exports.BlobRefType || (exports.BlobRefType = {}));
// Document Open Type
// Represents the method with which the document was opened at the client
var OpenType;
(function (OpenType) {
  // the document was newly created
  OpenType[OpenType["NewDocument"] = 0] = "NewDocument";
  // an old document opened for editing
  OpenType[OpenType["EditDocument"] = 1] = "EditDocument";
  // document to be viewed
  OpenType[OpenType["ViewOnlyDocument"] = 2] = "ViewOnlyDocument";
})(OpenType = exports.OpenType || (exports.OpenType = {}));
var GridConstants = /** @class */function () {
  function GridConstants() {}
  GridConstants.lowerIndexBound = 1;
  GridConstants.maxNumberOfRows = 1048576;
  GridConstants.maxNumberOfColumns = 16384;
  return GridConstants;
}();
exports.GridConstants = GridConstants;